export const PAGE_SIZE = 7;

